import { BeneficiaryModel } from '../../model/beneficiary.model';

export class InternalBeneficiaryModel extends BeneficiaryModel {
  public user_id: number;
  public cdc_code: string;
}
